import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { Venta } from "@/shared/types/venta";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function deleteVenta(id: string): Promise<Venta> {
    await sleep(1000);
    const response = await api.delete("ventas/" + id);
    return response.data;
}

export function useDeleteVentaMutation(id: string, mutationConfig: MutationConfig<Venta> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async () => await deleteVenta(id),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["ventas"] });
        },
    })
}

export interface DeleteVentaMutationProps{
    id: string, 
    mutationConfig?: MutationConfig<Venta>,
    children?:(mutationResult:MutationResult<Venta>)=>ReactNode
}

export function DeleteVentaMutation({
    id,
    children,
    mutationConfig
}:DeleteVentaMutationProps){
    const mutationResult = useDeleteVentaMutation(id, mutationConfig);
    return children&&children(mutationResult)
}